import React, { useState, useEffect } from "react";
// import {PieChart, Pie, Cell, ResponsiveContainer} from 'recharts';
import { useSelector } from "react-redux";
import { fetchUsersApi } from "../api/services/allExpenses";
import { RadialBarChart, RadialBar, ResponsiveContainer } from "recharts";
const UserStatusGraph = () => {
  const user = useSelector((state) => state.auth.user);
  const [activeUsers, setActiveUsers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);

  const fetchUsers = async () => {
    try {
      const response = await fetchUsersApi({ userRole: user.userRole.name });
      if (response) {
        const users = response;
        const activeStatusId = process.env.REACT_APP_STATUS_ACTIVE;

        const active = users.filter(
          (u) => u.status._id === activeStatusId,
        ).length;
        const total = users.length;

        setActiveUsers(active);
        setTotalUsers(total);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Prepare data for Recharts
  const pieData = [
    { name: "Active Users", value: activeUsers },
    { name: "Inactive Users", value: totalUsers - activeUsers },
  ];

  const COLORS = ["url(#gradientActive)", "#E0E0E0"]; // Active gradient + gray
  const activePercentage =
    totalUsers > 0 ? (activeUsers / totalUsers) * 100 : 0;

  const chartData = [
    {
      name: "Active",
      value: activePercentage,
      fill: "url(#gradientActive)",
    },
  ];
  return (
    <div className="h-full w-full bg-white rounded-xl p-3 border border-[#D5D7DA] shadow-lg flex flex-col">
      {/* Title */}
      <div className="mb-3">
        <p className="font-bold text-md text-gray-800">User Statistics</p>
        {/* <p className="text-xs text-gray-500">Active users radial overview</p> */}
      </div>

      <div className="flex flex-col md:flex-row items-center justify-center gap-6 h-full flex-1 min-h-0">
        {/* Radial Chart */}
        <div className="relative aspect-square h-full max-h-[280px] min-h-[180px]">
          <ResponsiveContainer width="100%" height="100%">
            <RadialBarChart
              cx="50%"
              cy="50%"
              innerRadius="72%"
              outerRadius="100%"
              barSize={12}
              startAngle={90}
              endAngle={-270}
              data={chartData}
            >
              <defs>
                <linearGradient id="gradientActive" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#3b82f6" />
                  <stop offset="100%" stopColor="#1d4ed8" />
                </linearGradient>
              </defs>

              <RadialBar
                data={[{ value: 100 }]}
                dataKey="value"
                fill="#e5e7eb"
                cornerRadius={999}
                clockWise
              />
              <RadialBar dataKey="value" cornerRadius={999} clockWise />
            </RadialBarChart>
          </ResponsiveContainer>

          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shadow mb-1">
              <i className="fa-solid fa-users text-blue-600 text-lg"></i>
            </div>
            <p className="text-xl font-bold text-gray-800">
              {activePercentage.toFixed(1)}%
            </p>
            <p className="text-xs text-gray-500">Active Users</p>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="flex flex-col gap-3 w-full md:w-auto  md:justify-center">
          <StatCard title="Total Users" value={totalUsers} />
          <StatCard title="Active Users" value={activeUsers} active />
          <StatCard title="Inactive Users" value={totalUsers - activeUsers} />
        </div>
      </div>
    </div>
  );
};

export default UserStatusGraph;

const StatCard = ({ title, value, active }) => {
  return (
    <div
      className={`rounded-xl p-2 5xl:p-4 border shadow-sm transition flex gap-2 items-center justify-center ${
        active ? "bg-blue-50 border-blue-200" : "bg-gray-50 border-gray-200"
      }`}
    >
      <p className="text-xs text-gray-500 uppercase mt-1">{title}</p>
      <p
        className={`text-lg font-bold ${
          active ? "text-blue-700" : "text-gray-800"
        }`}
      >
        {value}
      </p>
    </div>
  );
};
